import React from "react"
import MessageBuilderConstants from "./constants/MessageBuilderConstants"
import MessageBuilderActions from "./actions/MessageBuilderActions"
import Switch from "../Switch/Switch"
import i18n from "i18n-js"
import ErrorHelper from "../Errors/ErrorHelper"

export default class Scheduler extends React.Component {
  constructor(props) {
    super(props);
    this.rules = {
      reservation_created: [MessageBuilderConstants.IMMEDIATELY, MessageBuilderConstants.AFTER],
      room_canceled: [MessageBuilderConstants.IMMEDIATELY, MessageBuilderConstants.AFTER],
      reservation_start_date: [MessageBuilderConstants.IMMEDIATELY, MessageBuilderConstants.BEFORE, MessageBuilderConstants.AFTER],
      reservation_end_date: [MessageBuilderConstants.IMMEDIATELY, MessageBuilderConstants.BEFORE, MessageBuilderConstants.AFTER],
      scheduled_check_in: [MessageBuilderConstants.IMMEDIATELY, MessageBuilderConstants.BEFORE, MessageBuilderConstants.AFTER],
      scheduled_check_out: [MessageBuilderConstants.IMMEDIATELY, MessageBuilderConstants.BEFORE, MessageBuilderConstants.AFTER],
      actual_check_in: [MessageBuilderConstants.IMMEDIATELY, MessageBuilderConstants.AFTER],
      actual_check_out: [MessageBuilderConstants.IMMEDIATELY, MessageBuilderConstants.AFTER],
      room_edited: [MessageBuilderConstants.IMMEDIATELY, MessageBuilderConstants.AFTER],
      order_created: [MessageBuilderConstants.IMMEDIATELY, MessageBuilderConstants.AFTER],
      order_completed: [MessageBuilderConstants.IMMEDIATELY, MessageBuilderConstants.AFTER],
      voucher_created: [MessageBuilderConstants.IMMEDIATELY, MessageBuilderConstants.AFTER],
      voucher_completed: [MessageBuilderConstants.IMMEDIATELY, MessageBuilderConstants.AFTER],
    };
    this.state = {
      setOnce: false,
      lifecycle_event: this.props.message && this.props.message.lifecycle_event ? this.props.message.lifecycle_event : 'actual_check_in',
      time_period: this.props.message && this.props.message.time_period ? this.props.message.time_period : MessageBuilderConstants.IMMEDIATELY,
      time_value: this.props.message && this.props.message.time_value ? this.props.message.time_value : 1,
    }
    this.onChange = this.onChange.bind(this)
    this.onChangeSwitch = this.onChangeSwitch.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.message && !this.state.setOnce) {
      this.setState({
        setOnce: true,
        lifecycle_event: this.props.message.lifecycle_event || 'actual_check_in',
        time_period: this.props.message.time_period || MessageBuilderConstants.IMMEDIATELY,
        time_value: this.props.message.time_value || 1,
        always_send: typeof this.props.message.always_send !== 'undefined' ? this.props.message.always_send : true,
      });
    }
  }

  render() {
    return (
      <div>
        {this.renderLifecycleEventSection()}
        {this.renderTimePeriodSection()}
        {this.renderAlwaysSend()}
      </div>
    )
  }

  renderLifecycleEventSection() {
    return (
      <div className="form-group">
        <label>{I18n.t('event')}</label>
        <br />
        <select name="message[lifecycle_event]" value={this.state.lifecycle_event} onChange={this.onChange.bind(null, 'lifecycle_event')} className="form-control">
          <optgroup label={I18n.t('reservation') + " " + I18n.t('merge_tags')}>
            <option value="reservation_created">{I18n.t('reservation_created')}</option>
            <option value="reservation_start_date">{I18n.t('reservation_start_date')}</option>
            <option value="reservation_end_date">{I18n.t('reservation_end_date')}</option>
          </optgroup>
          <optgroup label={I18n.t('room') + " " + I18n.t('merge_tags')}>
            <option value="scheduled_check_in">{I18n.t('scheduled_check_in')}</option>
            <option value="scheduled_check_out">{I18n.t('scheduled_check_out')}</option>
            <option value="actual_check_in">{I18n.t('actual_check_in')}</option>
            <option value="actual_check_out">{I18n.t('actual_check_out')}</option>
            <option value="room_canceled">{I18n.t('room_canceled')}</option>
            <option value="room_edited">{I18n.t('room_edited')}</option>
          </optgroup>
          <optgroup label={I18n.t('order') + " " + I18n.t('merge_tags')}>
            <option value="order_created">{I18n.t('order_created')}</option>
            <option value="order_completed">{I18n.t('order_completed')}</option>
          </optgroup>
          <optgroup label={I18n.t('voucher') + " " + I18n.t('merge_tags')}>
            <option value="voucher_created">{I18n.t('voucher_created')}</option>
            <option value="voucher_completed">{I18n.t('voucher_completed')}</option>
          </optgroup>
        </select>
      </div>
    );
  }

  renderTimePeriodSection() {
    if (this.state.time_period == MessageBuilderConstants.BEFORE || this.state.time_period == MessageBuilderConstants.AFTER) {
      return (
        <div className="form-group">
          <label>{I18n.t('send_message')}</label>
          <br />
          <div className="container py-0">
            <div className="row">
              <select name="message[time_period]" value={this.state.time_period} onChange={this.onChange.bind(null, 'time_period')} className={ErrorHelper.renderFieldClasses('time_period', this.props.errors, 'form-control col-sm-7')}>
                {this.rules[this.state.lifecycle_event].indexOf(MessageBuilderConstants.IMMEDIATELY) == -1 ? null : <option value={MessageBuilderConstants.IMMEDIATELY}>{I18n.t('immediately')}</option>}
                {this.rules[this.state.lifecycle_event].indexOf(MessageBuilderConstants.BEFORE) == -1 ? null : <option value={MessageBuilderConstants.BEFORE}>{I18n.t('before')}</option>}
                {this.rules[this.state.lifecycle_event].indexOf(MessageBuilderConstants.AFTER) == -1 ? null : <option value={MessageBuilderConstants.AFTER}>{this.capitalize(I18n.t('after'))}</option>}
                {<option value={MessageBuilderConstants.MANUALLY}>{I18n.t('manually')}</option>}
              </select>
              <div className="col-sm-5 pr-0 input-group">
                <input name="message[time_value]" value={this.state.time_value} onChange={this.onChange.bind(null, 'time_value')} type="text" className="form-control days-input" />
                <span className="input-group-addon days">{I18n.t('days')}</span>
              </div>
            </div>
          </div>
          {ErrorHelper.renderFieldErrors('time_period', this.props.errors)}
        </div>
      );
    } else {
      return (
        <div className="form-group">
          <label>{I18n.t('send_message')}</label>
          <br />
          <select name="message[time_period]" value={this.state.time_period} onChange={this.onChange.bind(null, 'time_period')} className={ErrorHelper.renderFieldClasses('time_period', this.props.errors, 'form-control')}>
            {this.rules[this.state.lifecycle_event].indexOf(MessageBuilderConstants.IMMEDIATELY) == -1 ? null : <option value={MessageBuilderConstants.IMMEDIATELY}>{I18n.t('immediately')}</option>}
            {this.rules[this.state.lifecycle_event].indexOf(MessageBuilderConstants.BEFORE) == -1 ? null : <option value={MessageBuilderConstants.BEFORE}>{I18n.t('before')}</option>}
            {this.rules[this.state.lifecycle_event].indexOf(MessageBuilderConstants.AFTER) == -1 ? null : <option value={MessageBuilderConstants.AFTER}>{this.capitalize(I18n.t('after'))}</option>}
            {<option value={MessageBuilderConstants.MANUALLY}>{I18n.t('manually')}</option>}
          </select>
          {ErrorHelper.renderFieldErrors('time_period', this.props.errors)}
        </div>
      )
    }
  }

  renderAlwaysSend() {
    if (this.state.time_period == MessageBuilderConstants.BEFORE) {
      return (
        <div className="form-group">
          <label>{i18n.t("always_send")} <span className="ss-help help" title={I18n.t("always_send_helper_text")}></span></label>
          <div className="send-switch">
            <Switch onText="yes" switchId="always_send" offText="no" name="message[always_send]" onChange={this.onChangeSwitch} value={this.state.always_send}/>
          </div>
        </div>
      );
    }
  }

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  onChange(name, event) {
    var state = this.state;
    state[name] = event.target.value;
    if (event.target.value == "immediately") {
      state["time_value"] = null
      MessageBuilderActions.setValue("time_value", null);
    }

    if (event.target.value == "manually") {
      state["time_value"] = null;
      MessageBuilderActions.setValue("time_value", null);
    }

    if (["before", "after"].includes(event.target.value) && [null, 1].includes(state["time_value"])) {
      state["time_value"] = 1;
      MessageBuilderActions.setValue("time_value", 1);
    }

    if (['reservation_created', 'room_canceled', 'actual_check_in', 'actual_check_out', 'room_edited'].includes(event.target.value) && state['time_period'] == 'before') {
      state["time_period"] = 'immediately';
      state["time_value"] = null;
      MessageBuilderActions.setValue("time_period", 'immediately');
      MessageBuilderActions.setValue("time_value", null);
    }

    this.setState(state);
    MessageBuilderActions.setValue(name, event.target.value);
  }

  onChangeSwitch(always_send) {
    this.setState({
      always_send: always_send.target.checked
    })

    MessageBuilderActions.setValue("always_send", always_send.target.checked);
  }
};